<template>
    <div :class="community? 'roboroboPersonal communityPersonal' : 'roboroboPersonal'">
        <div class="top">
            <ul class="infoBox">
                <li>
                    <span>用户账号</span>
                    <input disabled v-model="currentUser.phone"  class="inputText" type="text">
                </li>
                <li>
                    <span>真实姓名</span>
                    <input :disabled="true" v-model="currentUser.name" class="inputText" type="text">
                </li>
                <li>
                    <span>性&emsp;&emsp;别</span>
                    <div class="sexBox">
                        <label><input class="radio_type" v-model="currentUser.sex" name="age" type="radio" value="男">男</label>
                        <label><input class="radio_type" v-model="currentUser.sex" name="age" type="radio" value="女">女</label>
                    </div>
                </li>
                <li>
                    <span>生&emsp;&emsp;日</span>
                    <select v-model="currentYear" @change="e => currentYear = e.target.value">
                        <option
                         :value="item" 
                         v-for="(item, index) in years" 
                         :key="index">{{ item }}</option>
                    </select>年
                    <select v-model="currentMonths" @change="e => currentMonths = e.target.value">
                        <option
                         :value="item" 
                         v-for="(item, index) in months" 
                         :key="index">{{ item }}</option>
                    </select>月
                    <select v-model="currentDay">
                        <option
                         :value="item" 
                         v-for="(item, index) in days" 
                         :key="index">{{ item }}</option>
                    </select>日
                </li>
                <li>
                    <button @click="submitChangeInfo">确认修改</button>
                </li>
            </ul>
            <div class="avatarBox">
                <ImageCropping
                 v-if="community"
                 :img="currentUser.avatar"
                 @changeAvatar="changeAvatar"></ImageCropping>
                 <ImageCropping
                 v-else
                 :img="currentUser.avatar.endsWith(`static.${institutionConfig.baseDomainName}/noavatar.png`)? defaultAvatar : currentUser.avatar"
                 @changeAvatar="changeAvatar"></ImageCropping>
                <span>点击更换头像</span>
            </div>
        </div>
        <span class="line"></span>
        <ul v-if="community? tourist : true">
            <li v-if="tourist">
                <span>微信通知</span>
                <div class="wxBox">
                    <div class="wxUserInfo" v-if="currentUser.wxNickname">
                        <img class="wxHeadImg" :src="currentUser.wxHeadImg" alt="">
                        <span>{{ currentUser.wxNickname }}</span>
                    </div>
                    <i @click="geterweoma" class="el-icon-circle-plus"></i>
                </div>
            </li>
            <li v-if="!community" class="btnflex">
                <button @click="changePassword">修改密码</button>
                <button class="logoutBtn" @click="logOut">退出登录</button>
            </li>
        </ul>
        <el-dialog
         title="微信扫码绑定"
         :visible.sync="erweimaDialogVisible"
         width="190px"
         :close-on-click-modal="false"
         :append-to-body="true"
         @close="closeErweimDialog">
            <div id="qrcode"></div>
        </el-dialog>
    </div>
</template>
<script>
import ImageCropping from '@/components/imageCropping';
import userApi from '@/request/api/user';
import classApi from '@/request/api/class';
import hmApi from '@/request/api/hm';
import wxApi from '@/request/api/wx';
import QRCode from 'qrcodejs2';
export default {
    props: {
        community: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
    },
    components: {
        ImageCropping
    },
    data() {
        return {
            date: new Date(),
            years: [],
            months: [],
            days: [],
            currentUser: {}, //缓存user对象
            currentYear: 2000,
            currentMonths: 1,
            currentDay: 1,
            avatarUploadUrl: "", //上传路径
            erweimaDialogVisible: false, //微信绑定二维码弹框显隐
            defaultAvatar: require('@/assets/roborobo/defaultavatar.png'),
            tourist: false
        }
    },
    watch: {
        currentYear() {
            this.getDays();
        },
        currentMonths() {
            this.getDays();
        },
        userInfo() {
            this.getUserinfo();
        }
    },
    created() {
        this.getUserinfo();
        this.getDate();
        this.getDays();
        if(this.userInfo.roles) {
            this.tourist = this.userInfo.roles.join('').includes('学生');
        }
    },
    methods: {
        //获取用户信息
        getUserinfo() {
            if(this.userInfo) {
                this.currentUser = Object.assign({}, this.userInfo)
                if(this.currentUser.birthday) {
                    this.currentYear = parseInt(this.currentUser.birthday.split('-')[0]);
                    this.currentMonths = parseInt(this.currentUser.birthday.split('-')[1]);
                    this.currentDay = parseInt(this.currentUser.birthday.split('-')[2]);
                }
            }
        },
        //token之后获取用户信息
        getCurrentUser() {
            userApi.getCurrentUser(res => {
                if(res.succeed) {
                    this.$store.commit('setDialogVisible', false)
                    this.$store.commit('setUserInfo', res.data)
                    this.$store.commit('setLoginBtnShow', false)
                    this.$router.replace('/roborobo/home')
                }
            })
        },
        closeErweimDialog() {
            wxApi.getStudentInfoById(this.userInfo.id, res => {
                if(res.succeed) {
                    this.$store.commit('setUserInfo', Object.assign({}, this.userInfo, {
                        wxHeadImg: res.data.wxHeadImg,
                        wxNickname: res.data.wxNickname
                    }))
                }
            })
        },
        //获取年月
        getDate() {
            var year = this.date.getFullYear();
            for(var i = 1990; i <= this.date.getFullYear(); i++) {
                this.years.unshift(i)
            }
            for(var i = 1; i <= 12; i++) {
                this.months.push(i)
            }
        },
        //获取天数
        getDays(){
            var d = new Date(this.currentYear, this.currentMonths, 0);
            var days = d.getDate();
            this.days = [];
            for(var i = 1; i <= days; i++) {
                this.days.push(i);
            }
        },
        //提交修改的信息
        submitChangeInfo() {
            if(this.currentYear && this.currentMonths && this.currentDay) {
                this.currentUser.birthday = `${this.currentYear}-${this.currentMonths}-${this.currentDay}`
            } else {
                this.$message({
                    message: '请填写正确的生日日期',
                    type: 'warning'
                });
                return;
            }
            if(this.currentUser.name == '') {
                this.$message({
                    message: '姓名不能为空',
                    type: 'warning'
                });
                return;
            }
            hmApi.saveStuSelfInfo(this.currentUser, res => {
                if(res.succeed) {
                    this.$store.commit('setUserInfo', Object.assign({}, this.userInfo, {
                        name: res.data.name,
                        birthday: res.data.birthday,
                        sex: res.data.sex,
                        avatar: res.data.avatar
                    }))
                    this.$message({
                        message: '修改成功',
                        type: 'success'
                    });
                }
            })
        },
        //修改头像
        changeAvatar(img) {
            this.currentUser.avatar = img;
        },
        //获取二维码
        geterweoma() {
            classApi.getStudentBindQrCode(this.userInfo.id, res => {
                if(res.succeed) {
                    this.erweimaDialogVisible = true;
                    $("#qrcode").empty();
                    this.$nextTick(() => {
                        this.createerweima(res.data);
                    })
                }
            })
        },
        createerweima(url) {
            let qrcode = new QRCode('qrcode', {
                width: 150,
                height: 150,
                text: url,
            })
        },
        //修改密码
        changePassword() {
            this.$emit('handleChangePassword');
        },
        //退出登录
        logOut() {
            userApi.deleteToken();
            this.$store.commit('setUserInfo', null);
            this.$router.replace('/roborobo/login');
        },
    },

}
</script>
<style lang="scss">
.roboroboPersonal {
    width: 945px;
    height: 550px;
    padding: 60px 60px 25px;
    background: url(~@/assets/roborobo/contentbg.png) no-repeat;
    background-size: 100% 100%;
    color: #888888;
    overflow: hidden;

    ul, li {
        padding: 0;
        margin: 0;
    }
    .line {
        display: block;
        width: 100%;
        margin: 0 -20px;
        border-bottom: 2px solid #DBDBDB;
    }
    .el-icon-circle-plus {
        font-size: 18px;
        cursor: pointer;
    }
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
    }
    .avatarBox {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        margin: 5px;
    }
    .avatarBox img {
        width: 80px;
        height: 80px;
        border: 2px solid #ccc;
        border-radius: 50%;
        cursor: pointer;
    
    }
    ul {
        margin-top: 20px;
    }
    ul li {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        font-size: 15px;
        font-weight: 900;
        font-family: PingFang SC;
        margin-bottom: 20px;
    }
    ul li span {
        margin-right: 25px;
    }
    select {
        border: none;
        background-color: #F7F7F7;
        padding: 2px 5px;
        margin: 5px;
    }
    select:focus {
        outline-color: #FFCB16;
    }
    option:hover {
        background-color: #FFCB16;
    }
    .sexBox,
    .sexBox label {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-right: 15px;
    }
    .sexBox input {
        margin: 0 5px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .btnflex {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
    }
    ul li button {
        color: #fff;
        font-weight: 600;
        padding: 6px 25px;
        margin-left: 90px;
        background-color: #FFCB16;
        border: none;
        outline: none;
        border-radius: 2px;
    }
    .logoutBtn {
        background-color: #f56c6c;
    }
    .inputText {
        width: 350px;
        padding: 3px 20px;
        border: none;
        outline: none;
        background: #F7F7F7;
    }
    input[disabled] {
        color: #B1B1B1;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        cursor: pointer;
        position: relative;
        border-radius: 50%;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    input[type="radio"]:focus {
        outline: none;
    }
    .radio_type {
        width: 20px;
        height: 20px;
        appearance: none;
        position: relative;
        outline: none;
    }
    .radio_type:before {
        content: "";
        width: 15px;
        height: 15px;
        border: 1px solid #8c939d;
        display: inline-block;
        border-radius: 50%;
        vertical-align: middle;
    }
    .radio_type:checked:before {
        content: "";
        width: 15px;
        height: 15px;
        border: 1px solid #FFCB16;
        display: inline-block;
        border-radius: 50%;
        vertical-align: middle;
    }
    .radio_type:checked:after {
        content: "";
        width: 9px;
        height: 9px;
        text-align: center;
        background: #FFCB16;
        border-radius: 50%;
        display: block;
        position: absolute;
    }
    .radio_type:checked + label {
        color: #edd19d;
    }
    .wxBox {
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .wxUserInfo {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 120px;
        padding: 5px 0;
        margin: 5px 10px 5px 0;
        background-color: #F7F7F7;
    }
    .wxUserInfo span {
        max-width: 95px;
        margin-right: 0;
        margin: 0 5px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    .wxHeadImg {
        width: 25px;
        height: 25px;
        border-radius: 50%;
    }
    .erweimaBox {
        position: absolute;
        top: -120px;
        right: -85px;
        width: 120px;
        height: 120px;
        padding: 10px;
        color: #888888;
        background-color: #fff;
        overflow: hidden;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
}
.communityPersonal {
    width: 100%;
    height: auto;
    background: none;
}
</style>


// WEBPACK FOOTER //
// src/components/personal.vue